import React from "react";
import {makeStyles} from "@mui/styles";
import {Dialog, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";

const useStyles = makeStyles(theme => ({
    paper: {
        maxWidth: "90%",
        minWidth: "300px",
        maxHeight: "90%",
        minHeight: "500px",
    },
}));

const PreviewHtmlDialog = (props) => {
    const { html, onCancel } = props;

    return <Dialog
        open={true}
        aria-labelledby="preview-html-dialog"
        classes={useStyles()}
    >
        <ClosableDialogTitle onClose={onCancel}>
            Preview
        </ClosableDialogTitle>
        <DialogContent className="preview-html-dialog">
            <iframe
                sandbox=""
                srcDoc={html}
                style={{
                    width: '100%',
                    height: 'calc(80vh)',
                    border: '1px solid #ccc',
                    backgroundColor: "#FFFFFF",
                    color: "#000000",
                }}
            />
        </DialogContent>
    </Dialog>
}

export default PreviewHtmlDialog;
